/**
 * @typedef {RenderableProps} _AbContainer_Props
 * @property {'round-rectangle'|'round-rectangle-left'|'round-rectangle-concealed-top-left'|'pill'|'pill-left'} type
 * @property {boolean} clickable
 * @property {function(event: MouseEvent)} onClick
 */
export function AbContainer({ type, clickable, children, onClick }) {
  return (
    <div className={`ab-container ab-type-${type} ${clickable ? 'ab-clickable' : ''}`} onClick={event => clickable && onClick(event)}>
      <div className="ab-header">
        <div className="ab-start">
          {children.find(c => c && c.props.place === 'header-start')}
        </div>
        <div className="ab-main">
          {children.find(c => c && c.props.place === 'header-main')}
        </div>
        <div className="ab-end">
          {children.find(c => c && c.props.place === 'header-end')}
        </div>
      </div>
      <div className="ab-contents">
        {children.find(c => c && c.props.place === 'contents')}
      </div>
      <div className="ab-footer">
        {children.find(c => c && c.props.place === 'footer')}
      </div>
    </div>
  );
}
